import { useQuery } from '@tanstack/react-query';
import { SponsorshipService } from '@/services/sponsorship.service';
import { CalendarSponsorship } from '@/types/booking.types';
import { shortCacheQueryOptions } from '@/config/react-query.config';

// Query key factory for calendar sponsorship
export const calendarSponsorshipKeys = {
  all: ['calendar-sponsorship'] as const,
  forCalendar: (calendarId: string, locationId?: string) =>
    [...calendarSponsorshipKeys.all, calendarId, locationId ?? ''] as const,
};

/**
 * Hook to get sponsorship data for a calendar (booking type).
 * Pass locationId for drop-in members so the API scopes to the visited location.
 * Disabled when calendarId is undefined or empty string.
 */
export const useCalendarSponsorship = (calendarId: string | undefined, locationId?: string) => {
  const query = useQuery<CalendarSponsorship | null, Error>({
    queryKey: calendarSponsorshipKeys.forCalendar(calendarId ?? '', locationId),
    queryFn: () => SponsorshipService.getCalendarSponsorship(calendarId as string, locationId),
    enabled: Boolean(calendarId),
    ...shortCacheQueryOptions,
  });

  return {
    data: query.data,
    isLoading: query.isLoading,
    error: query.error,
  };
};
